import { InteractionType, EventSource, MixpanelEvent, ComponentType } from '../MixPanelTypes';

export type ConfigItemEvents = 'RENAME' | 'TOGGLE';

export const configItem: Record<ConfigItemEvents, MixpanelEvent> = {
  RENAME: {
    eventDescription: 'Config Item Rename Action',
    eventKey: 'config-item-rename',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.PRIMARY_ACTION
  },
  TOGGLE: {
    eventDescription: 'Config Item Toggle Action',
    eventKey: 'config-item-toggle',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.TOGGLE_BUTTON
  }
} as const;
